import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useDialog } from '../../shared/context';
import { Button, Box } from '@mui/material';
import LinkSectorUserCreate from '../layout/linkSectorUser/LinkSectorUserCreate';
import LinkSectorUserConsult from '../layout/linkSectorUser/LinkSectorUserConsult';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SectorUserDialog = ({ handleCancel }) => {
  const sectorUserDialog = useDialog('sectorUserDialog');
  const [getComponent, setComponent] = useState('consult');
  const [getTitle, setTitle] = useState('Consultar vínculo de setor com usuário');

  const handleChangeComponent = (title, component) => {
    setComponent(component);
    setTitle(title);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
  };

  return (
    <Dialog
      open={sectorUserDialog.isDialogOpen()}
      TransitionComponent={Transition}
      keepMounted
      onClose={sectorUserDialog.closeDialog}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle sx={{ fontSize: '2em' }}>{getTitle}</DialogTitle>
      <DialogContent>
        <Box>
          {getComponent === 'consult' ? (
            <LinkSectorUserConsult handleChangeComponent={handleChangeComponent} />
          ) : (
            <LinkSectorUserCreate
              handleFormSubmit={handleFormSubmit}
              handleChangeComponent={handleChangeComponent}
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleCancel}>
          fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SectorUserDialog;
